/* @flow */
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';

import './styles/SchoolDetailView.scss';

type Props = {
  organizationProfile: OrganizationProfile,
}

type State = {
  showMap: boolean
}

class SchoolDetailView extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props: Props) {
    super(props);
    const school = props.organizationProfile;

    const hasLatLong = school.getLatitude() && school.getLongitude();

    this.state = {
      showMap: hasLatLong,
    };
  }

  state: State;

  componentDidMount() {
    const school = this.props.organizationProfile;
    const latitude = school.getLatitude();
    const longitude = school.getLongitude();

    const GoogleMapsLoader = require('google-maps');

    if (this.state.showMap) {
      GoogleMapsLoader.load((google) => {
        const latlng = new google.maps.LatLng(latitude, longitude);
        const mapOptions = {
          zoom: 15,
          center: latlng,
          mapTypeControl: false,
          scrollWheel: false,
          navigationControl: false,
          streetViewControl: false,
          zoomControl: false,
          draggable: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        };

        const map = new google.maps.Map(ReactDOM.findDOMNode(this.refs.googleMap), mapOptions);

        const marker = new google.maps.Marker({
          position: latlng,
          title: school.getName(),
        });
        marker.setMap(map);
      });
    }
  }

  redirectToAdminSignUp = () => {
    this.context.router.push('/school/sign_up');
  };

  renderDistrict = (school: OrganizationProfile) => {
    if (!school.getDistrictName()) {
      return null;
    }
    return (
      <div>
        <div className="SchoolDetailView-label">District:</div>
        <div className="SchoolDetailView-field district">
          {school.getDistrictName()}
        </div>
      </div>
    );
  };

  renderGradeLevels = (school: OrganizationProfile) => {
    if (!school.getGradeLevel()) {
      return null;
    }
    return (
      <div>
        <div className="SchoolDetailView-label">Grade levels:</div>
        <div className="SchoolDetailView-field gradeLevel">
          {school.getGradeLevel()}
        </div>
      </div>
    );
  };

  render() {
    const school = this.props.organizationProfile;
    const address = school.getAddressObject();

    return (
      <div className={cx('SchoolDetailView', this.props.className)}>
        <h3 className="SchoolDetailView-title">
          {school.getName()}
        </h3>

        <div className="SchoolDetailView-label">Address:</div>
        <div className="SchoolDetailView-field address">
          <div>{address.line1}</div>
          <div>{address.line2}</div>
          {this.state.showMap && <div ref="googleMap" className="SchoolDetailView-map" />}
        </div>

        {this.renderDistrict(school)}
        {this.renderGradeLevels(school)}


        <div className="SchoolDetailView-label">Type:</div>
        <div className="SchoolDetailView-field schoolType">
          {school.getFormattedType()} school
        </div>

        <div className="SchoolDetailView-claim">
          <Link onClick={this.redirectToAdminSignUp}>
            <Glyph name="school" size="large" />
            Administrator of this school? Claim school
          </Link>
        </div>
      </div>
    );
  }
}

export default SchoolDetailView;



// WEBPACK FOOTER //
// ./src/schools/components/SchoolDetailView.jsx